import React, { FC, useEffect, useState } from "react";

import LoanToValueForm from "./forms/LoanToValueForm";
import { LoanToValueCalculatorResults } from "./LoanToValueCalculatorResults";
import { calculateResults } from "./calculateResults";
import "./styles.scss";
import { useCalculatorStore } from "../store";
import { convertCurrencyStringToFloat } from "../../CalculatorPanels/calculatorMethods";
import { CalculatorTabLayout } from "../CalculatorTabLayout";
import { ValueType } from "./data";

export const LoanToValueCalculatorPanel: FC = () => {
  const [valueType, setValueType] = useState<ValueType>(ValueType.DEPOSIT_AMOUNT);
  const [shouldAnimate, setShouldAnimate] = useState(true);

  const {
    propertyValue,
    setPropertyValue,
    knownLTVValue,
    setKnownLTVValue
  } = useCalculatorStore();

  const handleAnimation = () => {
    setShouldAnimate(false);
  };

  useEffect(() => {
    setKnownLTVValue("");
    setShouldAnimate(true);
  }, [valueType]);

  const updateResults = () => {
    if (knownLTVValue === "" || propertyValue === "") return ["", ""];
    return calculateResults(convertedPropertyValue, convertedKnownValue, valueType);
  };
  const convertedPropertyValue = convertCurrencyStringToFloat(propertyValue);
  const convertedKnownValue = convertCurrencyStringToFloat(knownLTVValue);

  const results = updateResults();

  const form = (
    <LoanToValueForm
      valueType={valueType}
      setValueType={setValueType}
      propertyValue={propertyValue}
      setPropertyValue={setPropertyValue}
      knownValue={knownLTVValue}
      setKnownValue={setKnownLTVValue}
      handleAnimation={handleAnimation}
    />
  );

  const result = (
    <LoanToValueCalculatorResults
      resultType={valueType}
      shouldAnimate={shouldAnimate}
      results={results}
    />
  );

  return (
    <CalculatorTabLayout
      variant="LTV"
      form={form}
      result={result}
      disclaimer={<></>}
    />
  );
};
